import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  DemurrageDetentionStatisticFilterKeysEnum,
  ShipmentPlannerProfileFilterModel,
  StatisticFilterKeysEnum,
} from '../../shipment/models/shipment-filters.model';
import { PlannerProfileType } from '../../../../constants';
import { boschEmailValidator, mustNotBeBlankValidator } from '../../../../../common/utils';
import { ProfileSubscriptionBase } from '../../../../models';
import { ShipmentProfileReport, ShipmentProfileReportForm } from './shipment-planner-profile-report.model';
import { DayOfWeek, SchedulingType } from '../../../../../common';

export class ShipmentProfileModel {
  id: number | null = null;
  name: string | null = null;

  constructor(params?: ShipmentProfileModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ShipmentProfileForm {
  constructor(
    model: ShipmentProfileModel,
    public id: FormControl<number | null> = new FormControl<number | null>(model.id),
    public name: FormControl<string | null> = new FormControl<string | null>(model.name),
  ) {}
}

export class ShipmentProfileSubscription extends ProfileSubscriptionBase {
  emails: string[] = [];

  constructor(params?: ShipmentProfileSubscription) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ShipmentPlannerProfileDetails {
  id?: number;
  createdBy?: number;
  createdByEmail?: string;
  name: string;
  description: string;
  type: PlannerProfileType = PlannerProfileType.Private;
  isDefault = false;
  subscription: Partial<ShipmentProfileSubscription> = new ShipmentProfileSubscription();
  report: Partial<ShipmentProfileReport> = new ShipmentProfileReport();
  emails: string[] = [];

  constructor(params?: Partial<ShipmentPlannerProfileDetails>) {
    if (params) {
      Object.assign(this, params);
      if (!params.subscription) {
        this.subscription = new ShipmentProfileSubscription();
      }
      if (!params.report) {
        this.report = new ShipmentProfileReport();
      }
    }
  }
}

export class ShipmentPlannerProfileStatisticFilterModel {
  [StatisticFilterKeysEnum.Milestone]: string | null = null;
  [StatisticFilterKeysEnum.Deviation]: string | null = null;
  [StatisticFilterKeysEnum.Info]: string | null = null;
  [DemurrageDetentionStatisticFilterKeysEnum.ContainerCharges]: string | null = null;

  constructor(params?: ShipmentPlannerProfileStatisticFilterModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ShipmentPlannerProfileModel extends ShipmentPlannerProfileDetails {
  filter: ShipmentPlannerProfileFilterModel = new ShipmentPlannerProfileFilterModel();
  statisticFilter: ShipmentPlannerProfileStatisticFilterModel = new ShipmentPlannerProfileStatisticFilterModel();

  constructor(params?: ShipmentPlannerProfileModel) {
    super();
    if (params) {
      Object.assign(this, params);
      this.filter = new ShipmentPlannerProfileFilterModel(params.filter);
    }
  }
}

export class ShipmentProfileSubscriptionForm {
  constructor(
    model: Partial<ShipmentProfileSubscription>,
    fb: FormBuilder = new FormBuilder(),
    public id: FormControl<number> = fb.control<number>(model.id, []),
    public hours: FormControl<number[]> = fb.control<number[]>(model.hours, [Validators.required]),
    public schedulingType: FormControl<SchedulingType> = fb.control<SchedulingType>(model.schedulingType, [
      Validators.required,
    ]),
    public day: FormControl<DayOfWeek> = fb.control<DayOfWeek>(model.day, []),
    public emails: FormControl<string[]> = fb.control<string[]>(model.emails, [boschEmailValidator]),
  ) {}
}

export class ShipmentPlannerProfileDetailsForm {
  id?: FormControl<number>;
  createdBy?: FormControl<number>;
  createdByEmail?: FormControl<string>;
  constructor(
    model: ShipmentPlannerProfileDetails,
    fb: FormBuilder = new FormBuilder(),
    public name: FormControl<string> = fb.control<string>(model.name, [Validators.required, mustNotBeBlankValidator]),
    public description: FormControl<string> = fb.control<string>(model.description, []),
    public type: FormControl<PlannerProfileType> = fb.control<PlannerProfileType>(model.type, [Validators.required]),
    public isDefault: FormControl<boolean> = fb.control<boolean>(model.isDefault, []),
    public subscription: FormGroup<ShipmentProfileSubscriptionForm> = fb.group<ShipmentProfileSubscriptionForm>(
      new ShipmentProfileSubscriptionForm(model.subscription),
    ),
    public report: FormGroup<ShipmentProfileReportForm> = fb.group<ShipmentProfileReportForm>(
      new ShipmentProfileReportForm(model.report),
    ),
  ) {
    if (model.id) {
      this.id = fb.control<number>(model.id, []);
    }
    if (model.createdBy) {
      this.createdBy = fb.control<number>(model.createdBy, []);
    }
    if (model.createdByEmail) {
      this.createdByEmail = fb.control<string>(model.createdByEmail, []);
    }
  }
}
